const getPublicIpFromStorage = () => {
  const publicIp = localStorage.getItem('publicIpV4');

  return publicIp ? publicIp : null;
};

export default getPublicIpFromStorage;
